// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"90b5d2ae","455":"ea238723","977":"d50a9e80"}[chunkId] + ".chunk.js";
};